var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, InputLabel, Select, Grid, Card, CardContent, CardHeader, TextField, MenuItem, FormControl, DialogContent, Dialog, DialogTitle, DialogActions, CardActions, Stack, Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { inject, observer } from 'mobx-react';
import SmsOptionsEditor from './sms-options-editor';
import DisclaimerOptionsEditor from './disclaimer-options-editor';
import EmailTemplateEditor from './email-template-editor';
import CustomFieldsPanel from '../custom-fields/custom-fields-panel';
import CaseTypeFileCategoriesEditor from '../case-types/case-types-categories';
import CaseTypeDataScrambleEditor from './case-type-data-scramble';
import OfflineAssessmentEditor from './offline-assessment-editor';
import WorkflowEditor from '../offline-mode/settings/workflow-editor';
import CategoryIcon from '@mui/icons-material/Category';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ListIcon from '@mui/icons-material/List';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import SaveIcon from '@mui/icons-material/Save';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import OfflineShareIcon from '@mui/icons-material/OfflineShare';
import CssIcon from '@mui/icons-material/Css';
import CustomCssEditor from './custom-css-editor';
import CollectionsIcon from '@mui/icons-material/Collections';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';
import PhotoVideoSettings from './photo-video-settings';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { isNewId } from '../common/ids';
var CaseTypesEditor = /** @class */ (function (_super) {
    __extends(CaseTypesEditor, _super);
    function CaseTypesEditor(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.state = {
            isSmsEditorVisible: false,
            isFieldsEditorVisible: false,
            isCaseTypeCodePopupVisible: false,
            isDisclaimerEditorVisible: false,
            isEmailTemplateEditorVisible: false,
            isSettingsVisible: false,
            selectedCaseTypeCodeId: (_b = (_a = _this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.caseTypeCodes[0]) === null || _b === void 0 ? void 0 : _b.id,
            selectedTabValue: '1'
        };
        return _this;
    }
    Object.defineProperty(CaseTypesEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Card, { children: [_jsx(CardHeader, { title: _jsxs(Grid, __assign({ container: true, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx("h3", { children: "Case Types" }, void 0) }), void 0), _jsx(Grid, __assign({ container: true, item: true, xs: 8, justifyContent: "flex-end" }, { children: _jsxs(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onAddClick(); } }, { children: [_jsx(AddCircleIcon, {}, void 0), _jsx("span", { children: "Add New" }, void 0)] }), void 0) }), void 0)] }), void 0) }, void 0), _jsx(CardContent, { children: _jsxs(Grid, __assign({ container: true, minHeight: "200px", alignItems: "flex-start" }, { children: [this.renderCaseTypes(), this.renderCaseTypeCodePopup(), this.renderCaseTypeSettings()] }), void 0) }, void 0), _jsx(CardActions, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "flex-end", alignItems: "flex-end", sx: { width: '100%' } }, { children: [this.renderSaveButton(), this.renderCancelButton()] }), void 0) }, void 0)] }, void 0));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderCaseTypeSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this.state.isSettingsVisible)
                return null;
            return (_jsxs(Dialog, __assign({ className: "case-types-editor-dialog", open: true, onClose: function () { return _this.onCancelSettings(); }, fullWidth: true, maxWidth: false, PaperProps: {
                    sx: { height: '100%' }
                } }, { children: [_jsx(DialogTitle, { children: "Settings" }, void 0), _jsx(DialogContent, { children: _jsx(Card, { children: _jsx(CardContent, { children: _jsxs(TabContext, __assign({ value: this.state.selectedTabValue }, { children: [_jsx(Box, __assign({ sx: { borderBottom: 1, borderColor: 'divider' } }, { children: _jsxs(TabList, __assign({ className: "case-types-editor-tabs", onChange: function (event, newValue) { return _this.handleTabChange(event, newValue); }, variant: "scrollable", scrollButtons: "auto", "arial-label": "Case Types settings" }, { children: [_jsx(Tab, { icon: _jsx(ListIcon, {}, void 0), label: "Fields", iconPosition: "start", value: "1" }, void 0), _jsx(Tab, { icon: _jsx(SettingsSuggestIcon, {}, void 0), label: "Tickets", iconPosition: "start", value: "2" }, void 0), _jsx(Tab, { icon: _jsx(AssignmentTurnedInIcon, {}, void 0), label: "Disclaimer", iconPosition: "start", value: "3" }, void 0), _jsx(Tab, { icon: _jsx(CategoryIcon, {}, void 0), label: "Categories", iconPosition: "start", value: "4" }, void 0), _jsx(Tab, { icon: _jsx(Inventory2Icon, {}, void 0), label: "Data Scramble", iconPosition: "start", value: "5" }, void 0), _jsx(Tab, { icon: _jsx(OfflineShareIcon, {}, void 0), label: "Offline Assessment", iconPosition: "start", value: "6" }, void 0), _jsx(Tab, { icon: _jsx(FormatListNumberedOutlinedIcon, {}, void 0), label: "Guided Offline Assessment", iconPosition: "start", value: "7" }, void 0), _jsx(Tab, { icon: _jsx(CssIcon, {}, void 0), label: "Custom CSS", iconPosition: "start", value: "8" }, void 0), _jsx(Tab, { icon: _jsx(CollectionsIcon, {}, void 0), label: "Other Settings", iconPosition: "start", value: "9" }, void 0)] }), void 0) }), void 0), _jsx(TabPanel, __assign({ value: "1" }, { children: _jsx(CustomFieldsPanel, { isEditMode: true, isCaseTypeSelectorHidden: false, isAddressSelectionEnabled: true }, void 0) }), void 0), _jsxs(TabPanel, __assign({ value: "2" }, { children: [_jsx(SmsOptionsEditor, {}, void 0), _jsx("br", {}, void 0), _jsx(EmailTemplateEditor, {}, void 0)] }), void 0), _jsx(TabPanel, __assign({ value: "3" }, { children: _jsx(DisclaimerOptionsEditor, {}, void 0) }), void 0), _jsx(TabPanel, __assign({ value: "4" }, { children: _jsx(CaseTypeFileCategoriesEditor, {}, void 0) }), void 0), _jsx(TabPanel, __assign({ value: "5" }, { children: _jsx(CaseTypeDataScrambleEditor, {}, void 0) }), void 0), _jsx(TabPanel, __assign({ value: "6" }, { children: _jsx(OfflineAssessmentEditor, {}, void 0) }), void 0), _jsx(TabPanel, __assign({ value: "7" }, { children: _jsx(WorkflowEditor, {}, void 0) }), void 0), _jsx(TabPanel, __assign({ value: "8" }, { children: _jsx(CustomCssEditor, {}, void 0) }), void 0), _jsx(TabPanel, __assign({ value: "9" }, { children: _jsx(PhotoVideoSettings, {}, void 0) }), void 0)] }), void 0) }, void 0) }, void 0) }, void 0), _jsxs(DialogActions, { children: [_jsxs(Button, __assign({ variant: "contained", onClick: function () { return _this.onSaveSettings(); } }, { children: [_jsx(SaveIcon, {}, void 0), _jsx("span", { children: "Save" }, void 0)] }), void 0), _jsx(Button, __assign({ variant: "outlined", style: { marginLeft: '15px' }, onClick: function (e) { return _this.onCancelSettings(); } }, { children: "Cancel" }), void 0)] }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderCaseTypes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d;
            if (!((_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.caseTypes) === null || _b === void 0 ? void 0 : _b.length)) {
                return _jsx(Stack, __assign({ flex: "1", alignItems: "center" }, { children: "No items" }), void 0);
            }
            var options = (_c = this.props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.caseTypeCodes.map(function (t, index) {
                return _jsx(MenuItem, __assign({ value: t.id }, { children: t.name }), index);
            });
            var marginStyle = {
                marginRight: '10px'
            };
            return (_d = this.props.caseTypesStore) === null || _d === void 0 ? void 0 : _d.caseTypes.map(function (t, index) {
                return (_jsxs(Grid, __assign({ container: true, style: { marginBottom: '20px' }, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 1, style: marginStyle }, { children: _jsxs(FormControl, __assign({ fullWidth: true, variant: "outlined" }, { children: [_jsx(InputLabel, { children: "Type" }, void 0), _jsx(Select, __assign({ disabled: !t.isActive, value: t.caseTypeCodeID, label: "Type", onChange: function (e) { return _this.onTypeChange(e, t); } }, { children: options }), void 0)] }), void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !t.isActive, variant: "outlined", InputLabelProps: { shrink: true }, fullWidth: true, required: true, value: t.name, onChange: function (e) { return _this.onNameChange(e, t); }, label: "Name" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !t.isActive, variant: "outlined", InputLabelProps: { shrink: true }, fullWidth: true, value: t.description, onChange: function (e) { return _this.onDescriptionChange(e, t); }, label: "Description" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !t.isActive, InputLabelProps: { shrink: true }, variant: "outlined", type: "file", inputProps: { accept: ".docx" }, fullWidth: true, onChange: function (e) { return _this.onTemplateChange(e, t); }, label: "DOCX Template" }, void 0) }), void 0), _jsxs(Grid, __assign({ item: true, xs: 4, style: marginStyle }, { children: [_jsxs(Button, __assign({ disabled: !t.isActive, variant: "outlined", style: { marginLeft: '10px' }, onClick: function (e) { return _this.onSettingsButtonClick(t.id); } }, { children: [_jsx(SettingsIcon, {}, void 0), _jsx("span", { children: "Settings" }, void 0)] }), void 0), t.isActive ? _this.renderDeactivateButton(t) : _this.renderActivateButton(t)] }), void 0)] }), index));
            });
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderCaseTypeCodePopup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b;
            if (!this.state.isCaseTypeCodePopupVisible)
                return null;
            var options = (_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.caseTypeCodes) === null || _b === void 0 ? void 0 : _b.map(function (o, index) {
                return _jsx(MenuItem, __assign({ value: o.id }, { children: o.name }), index);
            });
            return (_jsxs(Dialog, __assign({ open: true, onClose: function () { return _this.onCloseCaseTypeCodePopupClick(false); } }, { children: [_jsx(DialogTitle, { children: "Select Case Type Code" }, void 0), _jsx(DialogContent, __assign({ sx: { minWidth: '300px' } }, { children: _jsx(Card, { children: _jsx(CardContent, { children: _jsxs(FormControl, __assign({ fullWidth: true, variant: "outlined" }, { children: [_jsx(InputLabel, __assign({ id: "idCaseTypeDropdown" }, { children: "Case Type Code" }), void 0), _jsx(Select, __assign({ labelId: "idCaseTypeDropdown", value: this.state.selectedCaseTypeCodeId, label: "Case Type Code", onChange: function (e) { return _this.onSelectedCaseTypeCodeValueChanged(e); } }, { children: options }), void 0)] }), void 0) }, void 0) }, void 0) }), void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", onClick: function () { return _this.onCloseCaseTypeCodePopupClick(true); } }, { children: _jsx("span", { children: "OK" }, void 0) }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return _this.onCloseCaseTypeCodePopupClick(false); } }, { children: "Cancel" }), void 0)] }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onSelectedCaseTypeCodeValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.setState(__assign(__assign({}, this.state), { selectedCaseTypeCodeId: e.target.value }));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onSaveSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            if ((_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.onSaveCaseTypes())
                this.setState(__assign(__assign({}, this.state), { isSettingsVisible: false }));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onCancelSettings", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState(__assign(__assign({}, this.state), { isSettingsVisible: false }));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onCloseCaseTypeCodePopupClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isOk) {
            var _a;
            this.setState(__assign(__assign({}, this.state), { isCaseTypeCodePopupVisible: false }));
            if (isOk) {
                (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.addCaseType(this.state.selectedCaseTypeCodeId);
            }
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderSaveButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Button, __assign({ variant: "contained", color: "primary", onClick: function (e) { return _this.onSaveClick(); } }, { children: [_jsx(SaveIcon, {}, void 0), _jsx("span", { children: "Save" }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderCancelButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsx(Button, __assign({ variant: "outlined", style: { marginLeft: '15px' }, onClick: function (e) { return _this.onCancelClick(); } }, { children: "Cancel" }), void 0));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onSaveClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.onSaveCaseTypes();
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onCancelClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            var onCancel = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.onCancel;
            if (onCancel)
                onCancel();
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onTypeChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseType) {
            var _a;
            var updatedCaseType = __assign(__assign({}, caseType), { caseTypeCodeID: e.target.value });
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseType(updatedCaseType);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onNameChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseType) {
            var _a;
            var updatedCaseType = __assign(__assign({}, caseType), { name: e.target.value });
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseType(updatedCaseType);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onDescriptionChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseType) {
            var _a;
            var updatedCaseType = __assign(__assign({}, caseType), { description: e.target.value });
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseType(updatedCaseType);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onTemplateChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, caseType) {
            var _this = this;
            var _a;
            var files = e.target.files;
            if (files.length === 0) {
                var updatedCaseType = __assign(__assign({}, caseType), { exportTemplate: '' });
                (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseType(updatedCaseType);
                return;
            }
            var fileReader = new FileReader();
            fileReader.onload = function (evt) {
                var _a;
                var updatedCaseType = __assign(__assign({}, caseType), { exportTemplate: fileReader.result.replace('data:', '').replace(/^.+,/, '') });
                (_a = _this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCaseType(updatedCaseType);
            };
            fileReader.readAsDataURL(files[0]);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderActivateButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseType) {
            var _this = this;
            return _jsxs(Button, __assign({ variant: "outlined", style: { marginLeft: '10px' }, onClick: function (e) { return _this.onActivateClick(caseType.id); } }, { children: [_jsx(RestoreFromTrashIcon, {}, void 0), _jsx("span", { children: "Activate" }, void 0)] }), void 0);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "renderDeactivateButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseType) {
            var _this = this;
            return _jsxs(Button, __assign({ variant: "outlined", style: { marginLeft: '10px' }, onClick: function (e) { return _this.onRemoveClick(caseType.id); } }, { children: [_jsx(DeleteIcon, {}, void 0), _jsx("span", { children: isNewId(caseType.id) ? 'Delete' : 'Deactivate' }, void 0)] }), void 0);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onSettingsButtonClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.setCurrentCaseType(caseTypeId);
            this.setState(__assign(__assign({}, this.state), { isSettingsVisible: true }));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onAddClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState(__assign(__assign({}, this.state), { isCaseTypeCodePopupVisible: true }));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onActivateClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.activateCaseType(caseTypeId);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onRemoveClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.removeCaseType(caseTypeId);
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "onEditFieldsClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseTypeId) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.setCurrentCaseType(caseTypeId);
            this.setState(__assign(__assign({}, this.state), { isFieldsEditorVisible: true }));
        }
    });
    Object.defineProperty(CaseTypesEditor.prototype, "handleTabChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, newValue) {
            this.setState(__assign(__assign({}, this.state), { selectedTabValue: newValue }));
        }
    });
    CaseTypesEditor = __decorate([
        inject('languageStore'),
        inject('caseTypesStore'),
        inject('fieldsStore'),
        observer
    ], CaseTypesEditor);
    return CaseTypesEditor;
}(React.Component));
export default CaseTypesEditor;
